<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <div class="basic-title"><em>面试结果分析</em></div>
            <div class="process">
              <el-row
                :gutter="20"
                class="process-label">
                <el-col :span="6">
                  <label>咨询老师：</label>
                  <el-select
                    class="jm-input280"
                    v-model="listInfoData.teacherIds"
                    placeholder="请选择"
                    multiple
                    filterable
                    clearable>
                    <el-option
                      v-for="option in teachers"
                      :key="option.userid"
                      :label="option.truename"
                      :value="option.userid"/>
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <label>申请学校：</label>
                  <jm-school-search
                    class="jm-input280"
                    clearable
                    filterable
                    :country-id="83"
                    v-model="schoolModel"/>
                </el-col>
                <el-col :span="6">
                  <label>创建时间：</label>
                  <el-date-picker
                    class="jm-input280"
                    v-model="listInfoData.createDate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-col>
                <el-col :span="6">
                  <label>接收时间：</label>
                  <el-date-picker
                    class="jm-input280"
                    v-model="listInfoData.acceptDate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-col>
                <el-col :span="6">
                  <label></label>
                  <el-button
                    type="primary"
                    @click="searchReport">搜索</el-button>
                  <el-button
                    type="primary"
                    @click="restSearch">重置</el-button>
                </el-col>
              </el-row>
              <jm-tableList
                url="/index/b_i_interview_form/getInterviewResult"
                :search-data="listInfoData"
                :refresh.sync="refresh"
                :page-size=20
              >
                <el-table-column
                  slot="uid"
                  slot-scope="scope"
                  v-bind="scope.attrs"
                  :label="scope.label"
                  property="uid">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.uid }}
                    </span>
                  </template>
                </el-table-column>
              </jm-tableList>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList.vue';
import { crumbs, jmAreaselect, jmSchoolSearch, jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      schoolModel: null,
      teachers: '',
      listInfoData: { // 初始数据
        schoolId: '', // 学校
        teacherIds: '',
        createDate: '',
        acceptDate: '',
      },
      refresh: false,
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmAreaselect,
    jmSchoolSearch,
    jmDictSelect
  },
  mounted() {
    this.getTeacherList();
  },
  methods: {
    searchReport() {
      this.refresh = true;
    },
    restSearch() {
      this.schoolModel = null;
      this.listInfoData.teacherIds = [];
      this.listInfoData.createDate = '';
      this.listInfoData.acceptDate = '';
    },
    getTeacherList() {
      this.$http._post({
        url: '/index/b_i_interview_form/getTeachers',
      }).then((response) => {
        this.teachers = Object.assign({}, this.teachers, response.data);
      });
    },
  },
  watch: {
    schoolModel(val) {
      this.listInfoData.schoolId = val ? val.sh_id : null;
    },
  }
};
</script>
<style scoped>
  .process-label label {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
  .process-label .el-col-6{
    margin-bottom: 10px;
    padding: 0 !important;
  }
  .process-bottom {
    margin-bottom: 10px;
    text-align: center;
  }
  .list-botton{
    margin-bottom: 10px;
  }
  .demo-table-expand {
    font-size: 0;
    text-align:center;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 14.28%;
  }
</style>
